import {
    FETCH_PENDING_ORDERS,
    FETCH_ORDER,
    FETCH_FINISHED_ORDERS,
    SET_PICKER_RATING,
    SET_FEEDBACK,
    RESET_ORDERS,
} from 'reducers/actions-types';
import { unionBy } from 'lodash';

export default function ordersReducer(
    state = {
        pendingOrders: {},
        finishedOrders: {},
        order: {},
    },
    { type, pendingOrders, finishedOrders, order }
) {
    switch (type) {
        case FETCH_PENDING_ORDERS:
            return {
                ...state,
                pendingOrders: {
                    orders: unionBy(state.pendingOrders.orders, pendingOrders.orders, 'id'),
                    total_count: pendingOrders.total_count,
                },
            };
        case FETCH_ORDER:
            return {
                ...state,
                order,
            };
        case FETCH_FINISHED_ORDERS:
            return {
                ...state,
                finishedOrders: {
                    orders: unionBy(state.finishedOrders.orders, finishedOrders.orders, 'id'),
                    total_count: finishedOrders.total_count,
                },
            };
        case SET_PICKER_RATING:
            return {
                ...state,
                order,
            };
        case RESET_ORDERS:
            return {
                isFetching: false,
                pendingOrders: {},
                finishedOrders: {},
            };
        case SET_FEEDBACK:
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/orders/index.js